import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Icon from '../atoms/Icon';
import Typography from 'material-ui/Typography';
import DateRange from '../controls/DateRange';
import { DateRanges } from '../../../constants/ComponentTypes';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import SearchIcon from '../../../assets/icons/search.svg';
import ArrowToolTip from '../../common/ArrowToolTip';
import Button from 'material-ui/Button';

const styles = () => ({
  root: {
    fontSize: '16px',
    color: '#181819',
    fontWeight: 'bold',
    marginBottom: '22px',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderBottom: '1px solid #E7E9EB',
    paddingBottom: '22px',
  },

  desc: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '22px',
  },

  left: {
    display: 'flex',
    alignItems: 'center',
  },

  right: {
    display: 'flex',
    alignItems: 'center',
  },

  search: {
    display: 'flex',
    alignItems: 'center',
  },

  searchIcon: {
    width: '20px',
    height: '20px',
    marginLeft: '8px',
    cursor: 'pointer',
    minWidth: 'unset',
  },
});

class PanelHeader extends React.Component {

  setContentRef = (node) => {
    this.contentRef = node;
    if (this.contentRef) {
      this.contentRef.addEventListener('keydown', this.handleEnterKeyPressed, false);
    }
  }

  handleEnterKeyPressed = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      this.props.handleSearch()
    }
  }

  render() {
    const { classes } = this.props;
    const now = new Date();
    const hours = now.getHours();
    const timesForInt = 10;
    const minutes = Math.floor(now.getMinutes() / timesForInt) * timesForInt;
    const roundDownMinute = 10;

    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.left}>
            {/* アイコンがない場合があるので */}
            {this.props.type !== null && (<Icon type={this.props.type} />)}
            <Typography variant="subheading" style={{ fontWeight: 'bold', fontSize: '16px' }}>{this.props.title}</Typography>
          </div>

          <div className={classes.right}>
            {this.props.handleSearch && (<div className={classes.search} ref={this.setContentRef}>
                <TextField
                  id="search"
                  type="search"
                  placeholder="oo株式会社 山田"
                  value={this.props.keyword}
                  onChange={this.props.handleChangeKeyword}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  fullWidth
                />
                <ArrowToolTip text={"入力した文字は空白を区切りとして「会社名 住所 氏名 役職」の項目をOR検索します。"}>
                  <Button
                    className={classes.searchIcon} onClick={this.props.handleSearch}
                  >
                    <img src={SearchIcon} alt="検索" />
                  </Button>
                </ArrowToolTip>
              </div>
            )}

            {this.props.dateRanges && (
              <DateRange isDemo={this.props.isDemo} dateRanges={this.props.dateRanges} dateSelected={this.props.dateSelected} handleSelectDate={this.props.handleSelectDate} togglePlanDialog={this.props.togglePlanDialog} />
            )}
          </div>
        </div>
        <div className={classes.desc}>
          {this.props.dateSelected && (<Typography variant="subheading" style={{ fontWeight: 'bold', fontSize: '12px' }}>{this.props.dateSelected.text}{this.props.dateSelected === DateRanges.UNSPECIFIED ? "" : "分を表示"}</Typography>)}
          {this.props.showUpdateDate && (
            <Typography variant="subheading" style={{ fontSize: '12px', marginLeft: "5px" }}>{"(最終更新 :  " + hours + ":" + (minutes < roundDownMinute ? "0" + minutes : minutes) + ")"}</Typography>
          )}
        </div>
      </div>
    )
  }
}

PanelHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isDemo: PropTypes.bool,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dateRanges: PropTypes.object,
  dateSelected: PropTypes.object,
  handleSelectDate: PropTypes.func,
  togglePlanDialog: PropTypes.func,
  showUpdateDate: PropTypes.bool,
  keyword: PropTypes.string,
  handleChangeKeyword: PropTypes.func,
  handleSearch: PropTypes.func,
};

PanelHeader.defaultProps = {
  showUpdateDate: true,
};

const mapStateToProps = (state) => {
  return {
    isDemo: state.accountSetting.showDemoData,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(PanelHeader));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/parts/PanelHeader.jsx